<div *ngIf="data">
	<div class="page-header">
		<h1 class="page-title">Network: {{data.partner.name}}</h1>
		<div>
			<strong>Status:</strong>
			<fa-icon [icon]="faClockRotateLeft" [size]="'lg'" class="" *ngIf="data.status == 'Uploaded'"></fa-icon>
			<fa-icon [icon]="faFileShield" [size]="'lg'" class="" *ngIf="data.status == 'Encrypting'"></fa-icon>
			<fa-icon [icon]="faClockRotateLeft" [size]="'lg'" class="me-1" *ngIf="data.status == 'Uploading'"></fa-icon>
			<fa-icon [icon]="faClockRotateLeft" [size]="'lg'" class="me-1" *ngIf="data.status == 'Pending'"></fa-icon>
			<fa-icon [icon]="faArrowsTurnToDots" [size]="'lg'" class="me-1 text-primary" *ngIf="data.status == 'Importing'"></fa-icon>
			<fa-icon [icon]="faArrowsTurnToDots" [size]="'lg'" class="me-1 text-primary" *ngIf="data.status == 'Processing'"></fa-icon>
			<fa-icon [icon]="faCheckCircle" [size]="'lg'" class="me-1 text-success" *ngIf="data.status == 'Completed'"></fa-icon>
			<fa-icon [icon]="faXmark" [size]="'lg'" class="me-1 text-danger" *ngIf="data.status == 'Failed'"></fa-icon>
			<span>{{data.status}}</span>
		</div>
	</div>
	<p>
		<strong>Time Taken:</strong> {{data.completionSection.timeTakenLabel}} &nbsp;&nbsp;
		<strong>Time Remaining:</strong> {{data.completionSection.completionEstimateInLabel}} &nbsp;&nbsp;
		<ng-container *ngIf="data.completionSection.completedAt"><strong>Completed At:</strong> {{data.completionSection.completedAt | date}}</ng-container>
	</p>
	<div class="row">
		<div class="col">
			<div class="h2 float-start" *ngIf="data.completionSection.completedAt">File Upload Validation Report [{{data.completionSection.completedAt}}]</div>
			<div class="h2 float-start" *ngIf="!data.completionSection.completedAt">File Upload Validation Report</div>
			<div class="float-end btn-group">
				<ng-container *ngIf="data.canDownloadRejectedFile">
					<button type="button" class="btn btn-sm btn-danger me-1" *hasPermission="['ImportDownloadRejections']" (click)="doDownloadRejections()">Download Rejections</button>
				</ng-container>
				<ng-container *ngIf="data.canDownloadOriginalFile">
					<button type="button" class="btn btn-sm btn-primary me-1" *hasPermission="['ImportDownloadOriginal']" (click)="doDownloadOriginal()">Download Original</button>
				</ng-container>
				<ng-container *ngIf="data.canDownloadOriginalFile && data.encryptionSection.completedAt && data.encryptionSection.failed == false">
					<button type="button" class="btn btn-sm btn-secondary" *hasPermission="['ImportDownloadOriginal']" (click)="doViewDecryptionKey()" placement="top" ngbTooltip="Show key to decrypt file">
						<fa-icon [icon]="faKey" [size]="'lg'"></fa-icon>
					</button>
				</ng-container>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<ngb-progressbar class="mb-3" [showValue]="true" [value]="data.completionSection.progressPercentage" [max]="100"/>
		</div>
	</div>

	<table class="table">
			<tr>
				<th>File Name</th>
				<td colspan="4">{{data.name}}</td>
			</tr>
			<tr>
				<th>Uploaded By</th>
				<td colspan="4">{{data.uploadSection.agent?.username??'System'}}</td>
			</tr>
			<tr>
				<th>Uploaded At</th>
				<td colspan="4">{{data.uploadSection.startedAt | date}}</td>
			</tr>
			<tr>
				<th>File Reference</th>
				<td colspan="4">{{data.id}}</td>
			</tr>
			<tr>
				<th>Uploaded Method</th>
				<td colspan="4">{{data.uploadSection.type}}</td>
			</tr>
			<tr>
				<th>&nbsp;</th>
				<th>Status</th>
				<th>Elapsed Time</th>
				<th *ngIf="data.status != 'Completed' && data.status != 'Failed'">Estimated Time Remaining</th>
				<th>Completed At</th>
			</tr>

			<tr>
				<th>Step 1: Upload</th>
				<td>
					<ng-container [ngSwitch]="data.status">
						<ng-container *ngSwitchCase="'Uploaded'">Waiting to start</ng-container>
						<ng-container *ngSwitchCase="'Uploading'">Uploading</ng-container>
						<ng-container *ngSwitchDefault>Done</ng-container>
					</ng-container>
				</td>
				<td>{{data.uploadSection.timeTakenLabel}}</td>
				<td *ngIf="data.status != 'Completed' && data.status != 'Failed'">0</td>
				<td>{{data.uploadSection.completedAt | date:'yyyy-MM-dd HH:mm:ss'}}</td>
			</tr>
			<tr>
				<th>Step 2: Importing</th>
				<td>
					<ng-container [ngSwitch]="data.status">
						<ng-container *ngSwitchCase="'Uploaded'">Pending</ng-container>
						<ng-container *ngSwitchCase="'Uploading'">Pending</ng-container>
						<ng-container *ngSwitchCase="'Pending'">Pending</ng-container>
						<ng-container *ngSwitchCase="'Importing'">Busy</ng-container>
						<ng-container *ngSwitchCase="'Encrypting'">Done</ng-container>
						<ng-container *ngSwitchCase="'Processing'">Done</ng-container>
						<ng-container *ngSwitchCase="'Completed'">Done</ng-container>
						<ng-container *ngSwitchCase="'Failed'">
							<ng-container *ngIf="data.importingSection.completedAt">Done</ng-container>
							<ng-container *ngIf="!data.importingSection.completedAt">Failed</ng-container>
						</ng-container>
					</ng-container>
				</td>
				<td>{{data.importingSection.timeTakenLabel}}</td>
				<td *ngIf="data.status != 'Completed' && data.status != 'Failed'">{{data.importingSection.completionEstimateInLabel}}</td>
				<td>{{data.importingSection.completedAt | date:'yyyy-MM-dd HH:mm:ss'}}</td>
			</tr>
			<tr>
				<th>Step 3: Encrypted</th>
				<td>
					<ng-container [ngSwitch]="data.status">
						<ng-container *ngSwitchCase="'Uploaded'">Pending</ng-container>
						<ng-container *ngSwitchCase="'Uploading'">Pending</ng-container>
						<ng-container *ngSwitchCase="'Pending'">Pending</ng-container>
						<ng-container *ngSwitchCase="'Importing'">Pending</ng-container>
						<ng-container *ngSwitchCase="'Encrypting'">Busy</ng-container>
						<ng-container *ngSwitchDefault>
							<ng-container *ngIf="data.encryptionSection.failed == true">Failed</ng-container>
							<ng-container *ngIf="data.encryptionSection.failed != true && data.encryptionSection.completedAt">Done</ng-container>
							<ng-container *ngIf="data.encryptionSection.failed != true && !data.encryptionSection.completedAt">Disabled</ng-container>
						</ng-container>
					</ng-container>
				</td>
				<td>{{data.encryptionSection.timeTakenLabel}}</td>
				<td *ngIf="data.status != 'Completed' && data.status != 'Failed'">-</td>
				<td>{{data.encryptionSection.completedAt | date:'yyyy-MM-dd HH:mm:ss'}}</td>
			</tr>
			<tr>
				<th>Step 4: Processing</th>
				<td>
					<ng-container [ngSwitch]="data.status">
						<ng-container *ngSwitchCase="'Uploaded'">Pending</ng-container>
						<ng-container *ngSwitchCase="'Uploading'">Pending</ng-container>
						<ng-container *ngSwitchCase="'Pending'">Pending</ng-container>
						<ng-container *ngSwitchCase="'Importing'">Busy</ng-container>
						<ng-container *ngSwitchCase="'Encrypting'">Busy</ng-container>
						<ng-container *ngSwitchCase="'Processing'">Busy</ng-container>
						<ng-container *ngSwitchCase="'Completed'">Done</ng-container>
						<ng-container *ngSwitchCase="'Failed'">
							<ng-container *ngIf="data.processingSection.completedAt">Done</ng-container>
							<ng-container *ngIf="!data.processingSection.completedAt">Failed</ng-container>
						</ng-container>
					</ng-container>
				</td>
				<td>{{data.processingSection.timeTakenLabel}}</td>
				<td *ngIf="data.status != 'Completed' && data.status != 'Failed'">{{data.processingSection.completionEstimateInLabel}}</td>
				<td>{{data.processingSection.completedAt | date:'yyyy-MM-dd HH:mm:ss'}}</td>
			</tr>
	</table>

	<div class="row">
		<div class="col bg-dark text-light h3 mt-3 mb-1">Summary</div>
	</div>
	<table class="table">
		<tbody>
			<tr>
				<th>Total Records</th>
				<td>{{data.uploadSection.lineCount | number}}</td>
			</tr>
			<tr>
				<th>Processed Records</th>
				<td>{{data.processingSection.statsProcessed| number}}</td>
			</tr>
			<tr>
				<th>Imported Records</th>
				<td>{{data.importingSection.statsImported| number}}</td>
			</tr>
			<tr>
				<th>Duplicate Records</th>
				<td>{{data.importingSection.statsDuplicate | number}} <span style="color: var(--ink-faint); font-style: italic;">(these are records that have been previously processed)</span></td>
			</tr>
			<tr>
				<th>Rejected Records</th>
				<td>{{data.rejectionSection.statsRejected | number}}</td>
			</tr>
			<tr>
				<th>Failed Records</th>
				<td>{{data.rejectionSection.statsFailure | number}} <span *ngIf="data.rejectionSection.statsFailure" class="text-danger">(Failed due to a system error)</span></td>
			</tr>
		</tbody>
	</table>
	<div class="row">
		<div class="col bg-dark text-light h3 mt-3 mb-1">Government Validation</div>
	</div>
	<table class="table">
		<tbody>
			<tr>
				<th colspan="2"><small>&nbsp;</small></th>
				<td><small>Passed from cache</small></td>
				<td><small>Passed while processing</small></td>
				<td><small>Total passed</small></td>
				<td><small>&nbsp;</small></td>
			</tr>
			<tr>
				<th colspan="2">Validated Records - Pass</th>
				<td>{{data.importingSection.statsTpValid}}</td>
				<td>{{data.processingSection.statsTpValid}}</td>
				<td>{{data.importingSection.statsTpValid+data.processingSection.statsTpValid}}</td>
				<td><span style="color: var(--ink-faint); font-style: italic;">(Persons details matched what is on Government records)</span></td>
			</tr>

			<tr class="mt-3">
				<th rowspan="4" class="w-auto"><small>Breakdown</small></th>
			</tr>

			<tr>
				<th>Perfect</th>
				<td>{{data.importingSection.statsTpDetailPerfect}}</td>
				<td>{{data.processingSection.statsTpDetailPerfect}}</td>
				<td>{{data.importingSection.statsTpDetailPerfect+data.processingSection.statsTpDetailPerfect}}</td>
				<td><small><span style="color: var(--ink-faint); font-style: italic;">Exactly matched the Government records</span></small></td>
			</tr>
			<tr>
				<th>Fuzzy Match</th>
				<td>{{data.importingSection.statsTpDetailMatch}}</td>
				<td>{{data.processingSection.statsTpDetailMatch}}</td>
				<td>{{data.importingSection.statsTpDetailMatch+data.processingSection.statsTpDetailMatch}}</td>
				<td><small><span style="color: var(--ink-faint); font-style: italic;">Name and/or Surname differ slightly from Government records - maybe a typo</span></small></td>
			</tr>
			<tr>
				<th>Half Match</th>
				<td>{{data.importingSection.statsTpDetailAcceptable}}</td>
				<td>{{data.processingSection.statsTpDetailAcceptable}}</td>
				<td>{{data.importingSection.statsTpDetailAcceptable+data.processingSection.statsTpDetailAcceptable}}</td>
				<td><small><span style="color: var(--ink-faint); font-style: italic;">Name and/or Surname differ from Government records</span></small></td>
			</tr>


			<tr>
				<th colspan="2"><small>&nbsp;</small></th>
				<td><small>Failed from cache</small></td>
				<td><small>Filed while processing</small></td>
				<td><small>Total Failed</small></td>
				<td><small>&nbsp;</small></td>
			</tr>
			<tr>
				<th colspan="2">Validated Records - Fail</th>
				<td>{{data.importingSection.statsTpInvalid}}</td>
				<td>{{data.processingSection.statsTpInvalid}}</td>
				<td>{{data.importingSection.statsTpInvalid+data.processingSection.statsTpInvalid}}</td>
				<td><span style="color: var(--ink-faint); font-style: italic;">(Persons details did not match what is on Government records)</span></td>
			</tr>

			<tr class="mt-3">
				<th rowspan="7" class="w-auto"><small>Breakdown</small></th>
			</tr>

			<tr>
				<th>Failed</th>
				<td>{{data.importingSection.statsTpDetailFailed}}</td>
				<td>{{data.processingSection.statsTpDetailFailed}}</td>
				<td>{{data.importingSection.statsTpDetailFailed+data.processingSection.statsTpDetailFailed}}</td>
				<td><small><span style="color: var(--ink-faint); font-style: italic;">Registered details don't match the Government records</span></small></td>
			</tr>
			<tr>
				<th>Deceased</th>
				<td>{{data.importingSection.statsTpDetailDeceased}}</td>
				<td>{{data.processingSection.statsTpDetailDeceased}}</td>
				<td>{{data.importingSection.statsTpDetailDeceased+data.processingSection.statsTpDetailDeceased}}</td>
				<td><small><span style="color: var(--ink-faint); font-style: italic;">According to the Government records - person was deceased at the time of registration </span></small></td>
			</tr>
			<tr>
				<th>Under Age</th>
				<td>{{data.importingSection.statsTpDetailUnderAge}}</td>
				<td>{{data.processingSection.statsTpDetailUnderAge}}</td>
				<td>{{data.importingSection.statsTpDetailUnderAge+data.processingSection.statsTpDetailUnderAge}}</td>
				<td><small><span style="color: var(--ink-faint); font-style: italic;">According to the Government records - person was under age at the time of registration </span></small></td>
			</tr>
			<tr>
				<th>Not Found</th>
				<td>{{data.importingSection.statsTpDetailNotFound}}</td>
				<td>{{data.processingSection.statsTpDetailNotFound}}</td>
				<td>{{data.importingSection.statsTpDetailNotFound+data.processingSection.statsTpDetailNotFound}}</td>
				<td><small><span style="color: var(--ink-faint); font-style: italic;">No Government records found for registration</span></small></td>
			</tr>
			<tr>
				<th>Skipped</th>
				<td>{{data.importingSection.statsTpDetailSkipped}}</td>
				<td>{{data.processingSection.statsTpDetailSkipped}}</td>
				<td>{{data.importingSection.statsTpDetailSkipped+data.processingSection.statsTpDetailSkipped}}</td>
				<td><small><span style="color: var(--ink-faint); font-style: italic;">Could not process - skipped</span></small></td>
			</tr>
			<tr>
				<th>Error</th>
				<td>{{data.importingSection.statsTpDetailError}}</td>
				<td>{{data.processingSection.statsTpDetailError}}</td>
				<td>{{data.importingSection.statsTpDetailError+data.processingSection.statsTpDetailError}}</td>
				<td><small><span style="color: var(--ink-faint); font-style: italic;">An error occurred while processing the registration</span></small></td>
			</tr>
		</tbody>
	</table>

	<div class="row">
		<div class="col bg-dark text-light h3 mt-3 mb-1">
			<span>Invalid/Rejected/Failed Record Breakdown</span>
			<small class="float-end h6 mt-2">Can have multiple errors per record</small>
		</div>
	</div>
	<table class="table">
		<thead>
			<tr>
				<th>Error Type</th>
				<th>Error Count</th>
			</tr>
		</thead>
		<tbody>
			<tr><td>Invalid Line Format</td><td>{{data.rejectionSection.statsInvalidLineFormat}}</td></tr>

			<tr><td>Invalid Registration Date</td><td>{{data.rejectionSection.statsInvalidRegistrationDate}}</td></tr>

			<tr><td>Invalid Msisdn</td><td>{{data.rejectionSection.statsInvalidMsisdn}}</td></tr>
			<tr><td>Invalid Iccid</td><td>{{data.rejectionSection.statsInvalidIccid}}</td></tr>
			<tr><td>Iccid Missmatch</td><td>{{data.rejectionSection.statsInvalidIccidMissmatch}}</td></tr>
			<tr><td>Invalid Sim Serial</td><td>{{data.rejectionSection.statsInvalidSimSerial}}</td></tr>

			<tr><td>Invalid Document Type</td><td>{{data.rejectionSection.statsInvalidDocumentType}}</td></tr>
			<tr><td>Invalid Document Number</td><td>{{data.rejectionSection.statsInvalidDocumentNumber}}</td></tr>
			<tr><td>Invalid ID Number</td><td>{{data.rejectionSection.statsInvalidIdNumber}}</td></tr>
			<tr><td>Invalid Given Names</td><td>{{data.rejectionSection.statsInvalidGivenNames}}</td></tr>
			<tr><td>Invalid Last Name</td><td>{{data.rejectionSection.statsInvalidLastName}}</td></tr>
			<tr><td>Invalid Gender</td><td>{{data.rejectionSection.statsInvalidGender}}</td></tr>
			<tr><td>Invalid Date Of Birth</td><td>{{data.rejectionSection.statsInvalidDateOfBirth}}</td></tr>
			<tr><td>Invalid Date Of Issue</td><td>{{data.rejectionSection.statsInvalidDateOfIssue}}</td></tr>
			<tr><td>Invalid Date Of Expiry</td><td>{{data.rejectionSection.statsInvalidDateOfExpiry}}</td></tr>
			<tr><td>Invalid Under Age</td><td>{{data.rejectionSection.statsInvalidUnderAge}}</td></tr>
			<tr><td>Invalid Deceased</td><td>{{data.rejectionSection.statsInvalidDeceased}}</td></tr>
			<tr><td>Invalid Issuing Country</td><td>{{data.rejectionSection.statsInvalidIssuingCountry}}</td></tr>
			<tr><td>Invalid Subscriber Type</td><td>{{data.rejectionSection.statsInvalidSubscriberType}}</td></tr>
			<tr><td>Invalid Contract Type</td><td>{{data.rejectionSection.statsInvalidContractType}}</td></tr>
			<tr><td>Invalid Nationality</td><td>{{data.rejectionSection.statsInvalidNationality}}</td></tr>
			<tr><td>Invalid Minor Given Names</td><td>{{data.rejectionSection.statsInvalidMinorGivenNames}}</td></tr>
			<tr><td>Invalid Minor Last Name</td><td>{{data.rejectionSection.statsInvalidMinorLastName}}</td></tr>
			<tr><td>Invalid Minor Date Of Birth</td><td>{{data.rejectionSection.statsInvalidMinorDateOfBirth}}</td></tr>
			<tr><td>Invalid Minor Gender</td><td>{{data.rejectionSection.statsInvalidMinorGender}}</td></tr>
		</tbody>
	</table>


	<div class="row">
		<div class="col bg-dark text-light h3 mt-3 mb-1">
			<span>Sample</span>
			<small class="float-end h6 mt-2">Sample showing first records in imported file.</small>
		</div>
	</div>
	<div class="table-responsive">
		<table class="table">
			<thead>
				<tr>
					<th>#</th>
					<th>Third Party Reference</th>
					<th>Msisdn</th>
					<th>Iccid</th>
					<th>Sim Serial</th>
					<th>Registration Date</th>
					<th>Subscriber Type</th>
					<th>Contract Type</th>
					<th>Document Type</th>
					<th>Document Number</th>
					<th>Id Number</th>
					<th>Date Of Issue</th>
					<th>Date Of Expiry</th>
					<th>Issuing Country</th>
					<th>Given Names</th>
					<th>Last Name</th>
					<th>Gender</th>
					<th>Date Of Birth</th>
					<th>Nationality</th>
					<th>Place Of Birth</th>
					<th>County</th>
					<th>Sub County</th>
					<th>Division</th>
					<th>Location</th>
					<th>Sub Location</th>
					<th>Minor Given Names</th>
					<th>Minor Last Name</th>
					<th>Minor Gender</th>
					<th>Minor Date Of Birth</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let sample of samples" [ngClass]="{'table-danger':sample.valid == false}">
					<td>{{sample.lineNumber}}</td>
					<td *ngIf="!sample.valid" colspan="28">{{sample.errorMessage}}</td>
					<ng-container *ngIf="sample.valid">
						<td [ngClass]="{'table-danger':sample.thirdPartyReference!.valid == false}">{{sample.thirdPartyReference!.value}}</td>
						<td [ngClass]="{'table-danger':sample.msisdn!.valid == false}">{{sample.msisdn!.value}}</td>
						<td [ngClass]="{'table-danger':sample.iccid!.valid == false}">{{sample.iccid!.value}}</td>
						<td [ngClass]="{'table-danger':sample.simSerial!.valid == false}">{{sample.simSerial!.value}}</td>
						<td [ngClass]="{'table-danger':sample.registrationDate!.valid == false}">{{sample.registrationDate!.value}}</td>
						<td [ngClass]="{'table-danger':sample.subscriberType!.valid == false}">{{sample.subscriberType!.value}}</td>
						<td [ngClass]="{'table-danger':sample.contractType!.valid == false}">{{sample.contractType!.value}}</td>
						<td [ngClass]="{'table-danger':sample.documentType!.valid == false}">{{sample.documentType!.value}}</td>
						<td [ngClass]="{'table-danger':sample.documentNumber!.valid == false}">{{sample.documentNumber!.value}}</td>
						<td [ngClass]="{'table-danger':sample.idNumber!.valid == false}">{{sample.idNumber!.value}}</td>
						<td [ngClass]="{'table-danger':sample.dateOfIssue!.valid == false}">{{sample.dateOfIssue!.value}}</td>
						<td [ngClass]="{'table-danger':sample.dateOfExpiry!.valid == false}">{{sample.dateOfExpiry!.value}}</td>
						<td [ngClass]="{'table-danger':sample.issuingCountry!.valid == false}">{{sample.issuingCountry!.value}}</td>
						<td [ngClass]="{'table-danger':sample.givenNames!.valid == false}">{{sample.givenNames!.value}}</td>
						<td [ngClass]="{'table-danger':sample.lastName!.valid == false}">{{sample.lastName!.value}}</td>
						<td [ngClass]="{'table-danger':sample.gender!.valid == false}">{{sample.gender!.value}}</td>
						<td [ngClass]="{'table-danger':sample.dateOfBirth!.valid == false}">{{sample.dateOfBirth!.value}}</td>
						<td [ngClass]="{'table-danger':sample.nationality!.valid == false}">{{sample.nationality!.value}}</td>
						<td [ngClass]="{'table-danger':sample.placeOfBirth!.valid == false}">{{sample.placeOfBirth!.value}}</td>
						<td [ngClass]="{'table-danger':sample.county!.valid == false}">{{sample.county!.value}}</td>
						<td [ngClass]="{'table-danger':sample.subCounty!.valid == false}">{{sample.subCounty!.value}}</td>
						<td [ngClass]="{'table-danger':sample.division!.valid == false}">{{sample.division!.value}}</td>
						<td [ngClass]="{'table-danger':sample.location!.valid == false}">{{sample.location!.value}}</td>
						<td [ngClass]="{'table-danger':sample.subLocation!.valid == false}">{{sample.subLocation!.value}}</td>
						<td [ngClass]="{'table-danger':sample.minorGivenNames!.valid == false}">{{sample.minorGivenNames!.value}}</td>
						<td [ngClass]="{'table-danger':sample.minorLastName!.valid == false}">{{sample.minorLastName!.value}}</td>
						<td [ngClass]="{'table-danger':sample.minorGender!.valid == false}">{{sample.minorGender!.value}}</td>
						<td [ngClass]="{'table-danger':sample.minorDateOfBirth!.valid == false}">{{sample.minorDateOfBirth!.value}}</td>
					</ng-container>
				</tr>
			</tbody>
		</table>
	</div>
</div>
